/*=========================================================================================
  File Name: moduleUserManagement.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleTextConvertState.js'
import mutations from './moduleTextConvertMutations.js'
import actions from './moduleTextConvertActions.js'
import getters from './moduleTextConvertGetters.js'

export default {
		namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
